import axios from "axios";
import {url} from "../utilities";
import {toastAlert} from "../toastAlert";
import * as $ from "jquery";

export const animal_deaths_page = () => {

    let deathsTable = $("#deathsTable").DataTable({
        stateSave:false,
        order: [1, 'desc'],
    });

    let animalTypeSelect = $('#addAnimalDeath_animal_type_id, #editAnimalDeath_animal_type_id');


    if($('#addAnimalDeath_animal_type_id, #editAnimalDeath_animal_type_id').children("option:selected").data('has_many_animals')){
        $(".animals").show();
    }else{
        $(".animals").hide();
    }


    animalTypeSelect.on('change', async function (e) {
        e.preventDefault();
        let id = $(this).children("option:selected").val();

        try {
            let response = await axios.get(url(`api/app/dictionary/animals?type_id=${id}`));
            let select = $("#addAnimalDeath_animal_id, #editAnimalDeath_animal_id");

            $(this).children("option[value='0']").remove();

            if($(this).children("option:selected").data('has_many_animals')) {
                $(".animals").show();
            }else{
                $(".animals").hide();
            }

            select.empty();

            let data = response.data;

            for (let animal of data.animals) {
                select.append(`<option value=${animal.id}>${animal.name}</option>`);
            }
        } catch (err) {
            toastAlert('Wystąpił błąd podczas dodawania upadku', {type: 'danger'})
        }

    });

    $('button[data-bs-target="#zipodModal"]').click(async function (){
        let id = $(this).data('id');
        let rid = $(this).data('rid');
        try {
            let response = await axios.get(url(`api/plan/deaths/${id}/get-zipod`));

            let data = response.data;
            if(data){
                $('.zipod__status').html(data.report.statusMessage);
                let date = new Date(data.report.date);

                $('.zipod__date').html(data.report.date);
                $('.zipod__created_by').html(data.author.first_name + ' ' + data.author.last_name ?? '');

                if(parseInt(data.report.status) === 3){
                    let zipodButton = $(`
                            <a class="btn btn-danger text-nowrap me-1 mb-1 zipodButton" href="${url(`app/zipod/${data.report.animal_death_id}/add-death`)}">
                                Wyślij ponownie
                            </a>
                        `)
                    $('.zipod__footer').prepend(zipodButton);
                }
            }

        }catch (e){
            toastAlert('Podczas pobierania danych wystąpił błąd. Spróbuj ponownie później', {type:'danger'})
        }
    })

}